<template>
  <div>
    <Menu/>
    <div class="text-bold">AirField</div>
    <div class="container grid-xs">
      <autocomplete
      :search="search"
      autoSelect
      placeholder="Name or Code"
      ref="autocomplete"
      :get-result-value="getResultValue"
      @focus="clear"
      @update="update"
      @submit="onSubmit"
      >
      </autocomplete>
    </div>
    <div class="text-bold">Date</div>
    <div>
    <date-picker v-bind:clearable="false" v-model="date" valueType="format"></date-picker>
    </div><br>
    <div :class="{buttdisabled: !airfield.name}">
      <button class="btn btn-action s-circle" 
      :disabled="airfield.name ? false : true"
      v-on:click="go">
      <i class="icon icon-arrow-right"></i>
      </button>
    </div>
    <div class="list-wrapper">
      <transition-group name="list" tag="div">
        <div class="list-item" v-for="evt in events" :key="evt.id">
        {{(evt.evt==1) ? '⤴': '⤵'}} <a class="c-hand" v-on:click="gocode(evt.code)" > {{evt.code}}</a>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
  import Menu from '@/components/menu.vue'
  import DatePicker from 'vue2-datepicker'
  import Autocomplete from '@trevoreyre/autocomplete-vue'
  import { format } from 'date-fns'
  import 'vue2-datepicker/index.css';
  const api_url = process.env.VUE_APP_APIURL 
  var today = format(new Date(), 'yyyy-MM-dd')
  export default {
    name: 'Home',
    components: { DatePicker, Autocomplete, Menu },
    data() {
      return {
        date: today,
        airfield: {},
        value: ''
      }
    },
    
    computed:{
      events () { return this.$store.state.socket.flightevts}
    },
    
    methods: {
    go () {
      let date_
      (today === this.date) ? date_ = null : date_ = this.date
      this.$router.push(['logbook', this.airfield.code, date_].join('/'))
      },
    
    gocode (code) {
      this.$router.push(['logbook', code].join('/'))
    },

    search(input) {
      this.value = input
      const url = `${api_url}/api/autocomp/${encodeURI(input)}`
      return new Promise(resolve => {
        if (input.length < 3) {return resolve([])}
        fetch(url)
          .then(response => response.json())
          .then(data => {
            if (this.value) {resolve(data)}
            else {resolve([])}
          })
      })
     },

     getResultValue(result) {
      return `${result.code} - ${result.name}`
     },
     clear() {
      this.value = ''
      this.$refs.autocomplete.value = ''
      this.airfield = {}
      },
      update() {
      },
     onSubmit(result) {
      if (result !== undefined) this.airfield = result
      else if (this.airfield.code !== undefined) this.go() 
     },
    },

    mounted (){
       this.airfield = this.$store.state.airfield
       if (this.airfield.code && this.airfield.name){this.$refs.autocomplete.value = `${this.airfield.code} - ${this.airfield.name}`} 
       if (this.$store.state.date) {this.date=this.$store.state.date}
     },
   };
</script> 
 
<style>

.buttdisabled
  {
    display: inline-block;
    cursor: not-allowed;
  }

.list-wrapper {
  width: 150px;
  margin: auto;
  margin-top: 20px;
}

.list-item {
  display: block;
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #cbd4f3;
  border-radius: 10px;
  font-weight: bold;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 1s cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}
.list-enter {
  opacity: 0;
  transform: translateY(50px) scaleY(0.5);
}
.list-enter-to {
  opacity: 1;
  transform: translateY(0) scaleY(1);
}
.list-leave-to {
  opacity: 0;
  transform: scaleY(0.5);
}
.list-leave {
  opacity: 1;
  transform: scaleY(1);
  transform: translateY(50px) scaleY(0.5);
}

.autocomplete-input{
    border:1px solid #eee;border-radius:8px;
    width:100%;
    padding:10px 10px 10px 12px;
    box-sizing:border-box;
    position:relative;
    font-size:14px;
    line-height:1;
    flex:1;
    background-color:#fff;
    background-repeat:no-repeat;
    background-position:12px}

.autocomplete-input:focus,

.autocomplete-input[aria-expanded=true]{
    border-color:rgba(0,0,0,.12);
    background-color:#fff;
    outline:none;
    box-shadow:0 2px 2px rgba(0,0,0,.16)}[data-position=below]

.autocomplete-input[aria-expanded=true]{
    border-bottom-color:transparent;
    border-radius:8px 8px 0 0}[data-position=above]

.autocomplete-input[aria-expanded=true]{
    border-top-color:transparent;
    border-radius:0 0 8px 8px;z-index:2}

.autocomplete[data-loading=true]:after{
    content:"";border:3px solid rgba(0,0,0,.12);
    border-right-color:rgba(0,0,0,.48);
    border-radius:100%;
    width:20px;
    height:20px;
    position:absolute;
    right:12px;top:50%;
    transform:translateY(-50%);
    animation:rotate 1s linear infinite}

.autocomplete-result-list{
    margin:0;border:1px solid rgba(0,0,0,.12);
    padding:0;
    box-sizing:border-box;
    max-height:296px;
    overflow-y:auto;
    background:#fff;
    list-style:none;
    box-shadow:0 2px 2px rgba(0,0,0,.16)}[data-position=below]

.autocomplete-result-list{
    margin-top:-1px;
    border-top-color:transparent;
    border-radius:0 0 8px 8px;
    padding-bottom:8px}[data-position=above]

.autocomplete-result-list{
    margin-bottom:-1px;
    border-bottom-color:transparent;
    border-radius:8px 8px 0 0;
    padding-top:8px}

.autocomplete-result{
    cursor:default;
    padding:6px 6px 6px 6px;
    background-repeat:no-repeat;
    background-position:12px}

.autocomplete-result:hover,

.autocomplete-result[aria-selected=true]{
    background-color:rgba(0,0,0,.06)}
@keyframes rotate{0%{transform:translateY(-50%) rotate(0deg)}to{transform:translateY(-50%) rotate(359deg)}}
</style>